import React, { ReactNode } from "react";
import { Channel as ChannelProps } from "stream-chat";
import { Channel, DefaultStreamChatGenerics } from "stream-chat-react";

export const UnstyledChannel = ({
  channel,
  children,
  fullheight = false,
}: {
  children: ReactNode;
  channel: ChannelProps<DefaultStreamChatGenerics>;
  fullheight?: boolean;
}) => {
  return (
    <div className={`t-group/unstyled ${fullheight ? "t-h-full" : ""}`}>
      <Channel channel={channel}>{children}</Channel>
    </div>
  );
};
